import { Appointment, SUBJECT_KEYS } from "@elixir/types";
import { TooltipComponent } from "ui";
import { ReactComponent as ChevronDownRegularIcon } from "../../../../assets/icons/font-awesome/chevron-down-regular.svg";
import { ReactComponent as CircleCheckSolidIcon } from "../../../../assets/icons/font-awesome/circle-check.svg";
import { ReactComponent as IndianRupeeSignRegularIcon } from "../../../../assets/icons/font-awesome/indian-rupee-sign-regular.svg";
import useBillingStore from "../../../../stores/billing-store/billing-store";
import useQueueStore from "../../../../stores/queue-store";
import useReceiptStore from "../../../../stores/receipt-store/receipt-store";
import { createNewReceipt, viewAllReceipt } from "../../../../utils/receipt";
import { getAclViewClassName } from "@elixir/utils";

const PaymentStatus = ({
  apt,
  className = "dr-col-span-2",
}: {
  apt: Appointment;
  className?: string;
}) => {
  const { billStatus, aid } = apt || {};
  const clinicId = useQueueStore((state) => state.clinicId);
  const setClinicId = useBillingStore((state) => state.setClinicId);
  const setReceiptPopupData = useReceiptStore(
    (state) => state.setReceiptPopupData
  );

  return (
    <TooltipComponent
      title={billStatus === "paid" ? "Paid" : "Create Bill"}
      placement="top"
    >
      <div
        className={`BodyBody2Regular dr-py-7 dr-px-8 dr-border-1 dr-border-darwin-touch-neutral-100 dr-rounded-4 dr-space-x-4 dr-leading-none flex items-center dr-h-32 ${
          billStatus === "paid"
            ? "dr-text-darwin-touch-green-dark"
            : "dr-text-darwin-touch-neutral-1000 dr-cursor-pointer"
        } ${className} ${getAclViewClassName(SUBJECT_KEYS.CAN_CREATE_RECEIPT_WITH_APT)}`}
        onClick={() => {
          if (!apt.receipts.length) {
            createNewReceipt({ appointment: apt });
          } else {
            viewAllReceipt({ appointment: apt });
          }
        }}
      >
        <IndianRupeeSignRegularIcon
          className={`w-14 h-14 dr-min-w-14 ${
            billStatus === "paid"
              ? "dr-text-darwin-touch-neutral-400"
              : "dr-text-darwin-touch-primary-primary"
          }`}
        />
        {billStatus === "paid" ? (
          <div className="dr-text-darwin-touch-green-dark flex flex-1 justify-between selection:items-center space-x-8">
            <div className="capitalize dr-line-clamp-1">{billStatus}</div>
            <CircleCheckSolidIcon className="dr-w-16" />{" "}
          </div>
        ) : (
          <div className="dr-text-darwin-touch-primary-primary flex flex-1 justify-between items-center space-x-8">
            <div className="capitalize dr-line-clamp-1">Create Bill</div>
            <ChevronDownRegularIcon className="dr-w-16 -dr-rotate-90" />{" "}
          </div>
        )}
      </div>
    </TooltipComponent>
  );
};

export default PaymentStatus;
